define('fukit/view/base.list.page.view',['require','exports','module','./base.page.view','./common/pagination.view','underscore','marionette','backbone','uikit/uikit','../templates','evicommon/pagination.util','./common/pageable.segmented.table.view','./common/page.header.view','../collection/spf.collection'],function(require, exports, module) {
  //prettier-ignore
  var BasePageView               = require('./base.page.view'),
      PaginationView             = require('./common/pagination.view'),
      _                          = require('underscore'),
      Mn                         = require('marionette'),
      Backbone                   = require('backbone'),
      UIKit                      = require('uikit/uikit'),
      Templates                  = require('../templates'),
      PaginationUtil             = require('evicommon/pagination.util'),
      PageableSegmentedTableView = require('./common/pageable.segmented.table.view'),
      PageHeaderView             = require('./common/page.header.view'),
      SpfCollection              = require('../collection/spf.collection');

  var BaseListPageView = BasePageView.extend({
    // use default list template (override this when needed in child view)
    template: Templates.FuKit['list.page'],

    options: {
      useVisualSearch: false,
    },

    // configure default options for elements on the page,
    // extend from these options in your specific page view
    internalViewOptions: BasePageView.extendInternalViewOptions({
      // page header
      pageHeaderView: function() {
        return {
          type: PageHeaderView,
          text: 'My Page',
          headerText: 'My Page',
          actions: [{ text: 'New Item', color: 'primary', icon: 'plus' }],
        };
      },

      // table element, where collection is displayed
      tableView: function() {
        var sortModel = null;
        if (this.collection instanceof SpfCollection) {
          sortModel = this.collection.sort;
        }
        return {
          type: PageableSegmentedTableView,
          selectable: true,
          basic: true,
          borderless: true,
          collection: this.collection,
          model: sortModel,
          bindings: {
            sortField: 'sort',
            sortDir: 'sort.dir',
          },
          tabletStackable: true,
          bottomAttached: this.getOption('useVisualSearch'),
          emptyText: 'No Items',
        };
      },

      // visual search input box
      tokenInputView: function() {
        return {
          type: UIKit.TokenInput,
          placeholder: 'Search',
          icon: 'search',
          fluid: true,
          singleValue: false,
          freeText: false,
        };
      },
    }),

    /**
     * Triggered when user double clicks on a table row of the UIKit table
     * @param  {UIKit.Table}            table   UIKit table element
     * @param  {UIKit.Table.RowView}    row     Specific row that triggered the action
     * @return {void}
     */
    onTableViewRowDoublePress: function(table, row) {
      this.trigger('item:open', row.model);
    },

    /**
     * Triggered when user performs an action on the table (such as choosing edit or delete)
     * @param  {UIKit.Table}          table   UIKit table element
     * @param  {UIKit.Table.RowView}  row     Specific row that triggered the action
     * @param  {Backbone.Model}       action  Action triggered
     * @return {void}
     */
    onTableViewRowAction: function(table, row, action) {
      var actionName = action.get('action');
      if (actionName) {
        this.trigger('item:' + actionName, row.model);
      }
    },
  });

  module.exports = BaseListPageView;
});

